export default {
  SET_SETTINGS: '@YOLA_EDITOR/EDITOR/SET_SETTINGS',
};
